//import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Hello World from React on Cloudflare Pages!</h1>
    </div>
  );
}

export default App;
